import {
  exportReportsParams,
  exportReportsService,
  fetchRoleReportsService,
  generateAIScoreService,
} from "api";
import { ConfirmationModal, Loader } from "components";
import { ExportReportModal } from "components/modalVariants/exportReport";
import { getError } from "helpers";
import { useApiRequest, useToast } from "hooks";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

interface Props {
  show: boolean;
  close: () => void;
}
const ExportReports: React.FC<Props> = ({ show, close }) => {
  const { id } = useParams();

  // Hooks
  const { openToast } = useToast();

  // API Request Hooks
  const { run, data: response, requestStatus, error } = useApiRequest({});

  const {
    run: runGen,
    data: genResponse,
    requestStatus: genStatus,
    error: genError,
  } = useApiRequest({});

  const fetchReports = (bucket?: string) =>
    id &&
    run(
      fetchRoleReportsService({
        page: "1",
        bucket: !!bucket ? (bucket === "all" ? "" : bucket) : "",
        assessment: id,
        search: "",
        progress: "",
        lower_score: "",
        upper_score: "",
      })
    );

  useEffect(() => {
    if (show) fetchReports();
  }, [show, id]);

  const handleGenerate = (params: exportReportsParams) =>
    runGen(
      exportReportsService({
        ...params,
      })
    );

  function downloadCSV(csvData: string, filename = "report.csv") {
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useMemo(() => {
    if (genResponse?.status === 200) {
      downloadCSV(genResponse.data, "candidate-report.csv");
    } else if (genError) {
      openToast({
        show: true,
        ...getError({
          error: genError,
          text: "Unable to initiate export, please try again later",
          heading: "Sorry",
        }),
        type: "error",
        timeOut: 5000,
      });
    }
  }, [genResponse, genError]);

  const showLoader = genStatus.isPending;

  return (
    <>
      <Loader loading={showLoader} />
      <ExportReportModal
        show={show}
        close={close}
        submit={handleGenerate}
        total_count={response?.data?.count ?? 0}
        fetchReports={fetchReports}
      />
    </>
  );
};

export { ExportReports };
